import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import type { SelectionMode } from "../index";

type SelectButtonProps = {
  selectionMode: SelectionMode;
  selectedCount: number;
  onCommit: () => void;
  className?: string;
};

export function SelectButton({
  selectionMode,
  selectedCount,
  onCommit,
  className,
}: SelectButtonProps) {
  const getLabel = () => {
    if (selectionMode === "single") {
      return "Select Tool";
    }
    if (selectedCount === 0) {
      return "Select Tools";
    }
    const noun = selectedCount === 1 ? "Tool" : "Tools";
    return `Use ${selectedCount} ${noun}`;
  };

  // In single mode, require exactly 1 tool
  // In multi mode, allowing 0 tools is permitted and we use this to indicate that all tools are selected in our MCP gateways
  const isDisabled = selectionMode === "single" && selectedCount !== 1;

  return (
    <Button
      className={className}
      data-testid="use-tools-button"
      disabled={isDisabled}
      onClick={onCommit}
      size="sm"
    >
      {getLabel()}
    </Button>
  );
}
